// import axios from 'axios';
// import HTTPService from './HTTP.service';

class SetupWidgetService {
	constructor(){
		this.settings = null;
	}
	getSetup(partnerId){
		// const url = HTTPService.getURLForService('setup-widget');
		const formData = new FormData();
		formData.append('id', partnerId);

		this.settings = {
			widgetVersion: 3 // hardcode in as old site no longer used for production
		};
		return this.settings;

		// return axios.post(url, formData).then(
		// 	(results) => {
		// 		if ( results.data.statusCode!==201) return Promise.reject(results.data.message);
		// 		const pagehitId = results.data.data._id;
		// 		return pagehitId;
		// 	}
		// );
	}
}

const setupWidgetService = new SetupWidgetService();

export default setupWidgetService;


// WEBPACK FOOTER //
// ./src/services/SetupWidget.service.js